export default function ({ redirect, route, store }) {
  if (store.state.globals.isMaintenance && route.path !== '/maintenance') {
    return redirect('/maintenance')
  }
}
